// extracted by mini-css-extract-plugin
module.exports = {"card":"CardHorizontal4_card__GgvZS","cardBody":"CardHorizontal4_cardBody__LjhE_"};